import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { useTheme } from "../state/theme.tsx";

const NAV = [
  { to: "/", label: "Ask", end: true },
  { to: "/sources", label: "Sources", end: false },
  { to: "/about", label: "About", end: false },
];

export function Layout({ children }: { children: ReactNode }) {
  const { theme, toggleTheme } = useTheme();
  return (
    <div className="min-h-full flex flex-col">
      <header
        className="sticky top-0 z-10 border-b backdrop-blur"
        style={{
          background: "color-mix(in srgb, var(--nl2s-surface) 88%, transparent)",
          borderColor: "var(--nl2s-border)",
        }}
      >
        <div className="mx-auto flex max-w-5xl items-center gap-4 px-4 py-3">
          <NavLink to="/" className="flex items-center gap-2 no-underline">
            <span
              className="grid h-8 w-8 place-items-center rounded-lg font-mono text-sm font-bold"
              style={{ background: "var(--nl2s-accent)", color: "var(--nl2s-accent-contrast)" }}
            >
              nl
            </span>
            <span className="text-lg font-semibold tracking-tight" style={{ color: "var(--nl2s-text)" }}>
              nl2sparql
            </span>
            <span
              className="hidden rounded-full px-2 py-0.5 text-[11px] font-medium sm:inline"
              style={{ background: "var(--nl2s-accent-soft)", color: "var(--nl2s-accent)" }}
            >
              Wikidata · M1
            </span>
          </NavLink>

          <nav className="ml-auto flex items-center gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className="rounded-md px-3 py-1.5 text-sm no-underline transition-colors"
                style={({ isActive }) => ({
                  color: isActive ? "var(--nl2s-accent)" : "var(--nl2s-text-muted)",
                  background: isActive ? "var(--nl2s-accent-soft)" : "transparent",
                })}
              >
                {item.label}
              </NavLink>
            ))}
            <button
              type="button"
              onClick={toggleTheme}
              className="ml-1 grid h-8 w-8 place-items-center rounded-md text-sm"
              style={{ color: "var(--nl2s-text-muted)", background: "var(--nl2s-surface-raised)" }}
              aria-label="Toggle theme"
              title="Toggle light/dark"
            >
              {theme === "dark" ? "☀" : "☾"}
            </button>
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-6">{children}</main>

      <footer
        className="border-t px-4 py-4 text-center text-xs"
        style={{ borderColor: "var(--nl2s-border)", color: "var(--nl2s-text-muted)" }}
      >
        Deterministic-first NL → SPARQL · runs entirely in your browser against the Wikidata Query Service.
      </footer>
    </div>
  );
}
